var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStomataScopeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 74.7 69.4",
    style: {
      enableBackground: "new 0 0 74.7 69.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#B6B6B6;stroke-width:8;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#CCCCCC;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#666666;stroke-width:8;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#666666;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 31.7,
    cy: 32.5,
    r: 26.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 51.9,
    y1: 50,
    x2: 68.3,
    y2: 64.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 33.1,
    cy: 31.7,
    r: 26.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 53.3,
    y1: 49.2,
    x2: 69.7,
    y2: 63.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStomataScopeLogo);
export default __webpack_public_path__ + "static/media/StomataScopeLogo.34d2b97947741ecb39ddce8d2623f27a.svg";
export { ForwardRef as ReactComponent };